import React from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from '@refinedev/core';
import { endPoints } from '@/api/configs';
import useAPI from '@/api/useApi';

interface AddEmbedPlatformModalProps {
  open: boolean;
  onCancel: () => void;
  refetch: () => void;
}

export const AddEmbedPlatformModal: React.FC<AddEmbedPlatformModalProps> = ({
  open,
  onCancel,
  refetch,
}) => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();
  const { usePatch } = useAPI();
  const { mutate: addEmbedPlatform, isLoading } = usePatch(
    endPoints.systemConfig
  );

  const handleOk = () => {
    form.validateFields().then((values) => {
      addEmbedPlatform(
        {
          operation: 'ADD',
          field: 'ALLOWED_EMBED_PLATFORM',
          value: values.name.trim(),
        },
        {
          onSuccess: () => {
            message.success(
              translate('system-config.embed-platforms.added-success')
            );
            form.resetFields();
            refetch();
            onCancel();
          },
          onError: (error) => {
            message.error(error.message);
          },
        }
      );
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={isLoading}
      title={translate('system-config.embed-platforms.add-title')}
      okText={translate('buttons.save')}
      cancelText={translate('buttons.cancel')}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label={translate('system-config.embed-platforms.name')}
          rules={[
            {
              required: true,
              message: translate('pages.errors.required'),
            },
          ]}
        >
          <Input
            placeholder={translate(
              'system-config.embed-platforms.name-placeholder'
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
